/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRowOptionFragmentDoc } from './SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRow.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AddUserVariableDefinitionValueSelectOptionInput = {
  name: string;
  userVariableDefinitionGUID: string | number;
};

export type SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOptionFragment = { guid: string, name: string };

export type AddUserVariableDefinitionValueSelectOptionMutationVariables = Exact<{
  input: Types.AddUserVariableDefinitionValueSelectOptionInput;
}>;


export type AddUserVariableDefinitionValueSelectOptionMutation = { addUserVariableDefinitionValueSelectOption: { void: any } };

export const SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOptionFragmentDoc = gql`
    fragment SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOption on UserVariableDefinitionValueSelectOption {
  ...SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRowOption
}
    ${SettingsPageLineActivationUserVariableDefinitionValueSelectOptionEditRowOptionFragmentDoc}`;
export const AddUserVariableDefinitionValueSelectOptionDocument = gql`
    mutation AddUserVariableDefinitionValueSelectOption($input: AddUserVariableDefinitionValueSelectOptionInput!) {
  addUserVariableDefinitionValueSelectOption(input: $input) {
    void
  }
}
    `;

/**
 * __useAddUserVariableDefinitionValueSelectOptionMutation__
 *
 * To run a mutation, you first call `useAddUserVariableDefinitionValueSelectOptionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useAddUserVariableDefinitionValueSelectOptionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useAddUserVariableDefinitionValueSelectOptionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useAddUserVariableDefinitionValueSelectOptionMutation(options: VueApolloComposable.UseMutationOptions<AddUserVariableDefinitionValueSelectOptionMutation, AddUserVariableDefinitionValueSelectOptionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<AddUserVariableDefinitionValueSelectOptionMutation, AddUserVariableDefinitionValueSelectOptionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<AddUserVariableDefinitionValueSelectOptionMutation, AddUserVariableDefinitionValueSelectOptionMutationVariables>(AddUserVariableDefinitionValueSelectOptionDocument, options);
}
export type AddUserVariableDefinitionValueSelectOptionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<AddUserVariableDefinitionValueSelectOptionMutation, AddUserVariableDefinitionValueSelectOptionMutationVariables>;